/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/support_medium'
export default icon
